import creditCardType from 'credit-card-type';

import {
  PaymentMethodInput,
  PliromyPreprocessorParameters,
} from '@cashier/cashier-model';

export const DataConverter = {
  toAuthToken: (parameters: PliromyPreprocessorParameters): string => {
    return btoa(`${parameters.username}:${parameters.password}`);
  },
  toTokenizePayload: (paymentInputs: Record<string, PaymentMethodInput>) => {
    const [cardExpireMonth, cardExpireYear] = (
      paymentInputs['expirationDate'].value as string
    ).split('/');

    const cardNumber = paymentInputs.creditcardNumber?.value as string;
    const cardType = creditCardType(cardNumber)[0]?.type || 'unknown';

    return {
      paymentMethod: cardType,
      holder: paymentInputs.cardHolder?.value as string,
      cardNumber: cardNumber,
      expiryMonth: Number(cardExpireMonth),
      expiryYear: Number(cardExpireYear),
      cvc: paymentInputs.cvv?.value as string,
    };
  },
  toMaskedCardNumber: (cardNumber: string): string => {
    const cardWithoutSpaces = cardNumber.replace(/\s/g, '');
    return cardWithoutSpaces.replace(
      /^(\d{6})(\d+)(\d{4})$/,
      (_, first6, middle, last4) => {
        return first6 + 'x'.repeat(middle.length) + last4;
      },
    );
  },
};
